import {useEffect, useRef, useState} from "react";

const RowTRComponent = ({
    fieldName,
    _TC,
    valueIn,
    hasIn,
    setHasIn = null,
    styleCenterMiddle,
    deactivated = null,
    type = "text",
    inputProps = {},
}) => {
    const [value, setValue] = useState("");
    const [has, setHas] = useState(false);
    const last = useRef(null);

    const changeHas = (e) => {
        setHas(e.target.checked);
        if (setHasIn) setHasIn(e.target.checked);
        if (!e.target.checked && deactivated) {
            last.current = value;
            setValue(deactivated);
        } else {
            setValue(last.current);
        }
    };

    useEffect(() => {
        setValue(valueIn);
        setHas(hasIn);
        last.current = valueIn;
    }, [hasIn, valueIn]);

    return (
        <tr>
            <td>{_TC(fieldName)}</td>
            <td>{_TC(`${fieldName}.description`)}</td>
            <td>
                <div className="row">
                    <div className="col-md-8">
                        <div className="text-md-end mt-2">
                            <label htmlFor={fieldName} className="form-label">
                                {_TC(fieldName)}
                            </label>
                        </div>
                    </div>
                    <div className="col-md-4 d-flex align-items-center">
                        <input
                            type={type}
                            id={fieldName}
                            name={fieldName}
                            className="mb-2 form-control text-end"
                            title={_TC(fieldName)}
                            value={value}
                            onChange={(e) => setValue(e.target.value)}
                            disabled={!has}
                            {...inputProps}
                        />
                    </div>
                </div>
            </td>
            <td style={styleCenterMiddle}>
                <div className="form-switch">
                    <input
                        type="checkbox"
                        id={`has-${fieldName}`}
                        name={`has-${fieldName}`}
                        className="form-check-input"
                        checked={has}
                        onChange={changeHas}
                    />
                </div>
            </td>
        </tr>
    );
};
export default RowTRComponent;
